import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  // Dashboard, AccountCircleOutlined, LocalShipping, CreditCard,
  Menu,
  Store,
  PointOfSale,
  PersonOutlineOutlined,
  ExitToApp
} from '@mui/icons-material';

import './SideBar.scss';

const Sidebar: React.FunctionComponent = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      <Menu className="menuButton" onClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className="sidebar" style={sidebarOpen ? { display: 'none' } : {}}>
        <div className="top">
          <span className="logo">Адміністратор</span>
        </div>
        <hr style={sidebarOpen ? { display: 'none' } : {}} />
        <div className="center" style={sidebarOpen ? { display: 'none' } : {}}>
          {/* <p id="dashboard" className="title">
            Панель спостереження
          </p>
          <ul>
            <li>
              <Dashboard className="icon" />
              <span id="home">Home</span>
            </li>
            <li>
              <span id="sales">Продажі</span>
            </li>
            <li>
              <span id="analytics">Аналітика</span>
            </li>
          </ul> */}
          <p id="operations" className="title">
            Рух коштів
          </p>
          <ul>
            <Link to="/sales" style={{ textDecoration: 'none' }}>
              <li>
                <PointOfSale className="icon" />
                <span id="sales">Продажі</span>
              </li>
            </Link>
          </ul>
          <p id="lists" className="title">
            Словники
          </p>
          <ul>
            <Link to="/products" style={{ textDecoration: 'none' }}>
              <li>
                <Store className="icon" />
                <span id="products">Товари</span>
              </li>
            </Link>
            {/* <li>
              <CreditCard className="icon" />
              <span id="orders">Замовлення</span>
            </li> */}
            {/* <li>
              <LocalShipping className="icon" />
              <span id="delivery">Доставка</span>
            </li> */}
            <Link to="/suppliers" style={{ textDecoration: 'none' }}>
              <li>
                <PersonOutlineOutlined className="icon" />
                <span id="suppliers">Постачальники</span>
              </li>
            </Link>
          </ul>
          <p className="title">Користувач</p>
          <ul>
            {/* <li>
              <AccountCircleOutlined className="icon" />
              <span id="profile">Профіль</span>
            </li> */}
            <li
              onClick={() => {
                localStorage.removeItem('a');
                window.location.reload();
              }}
            >
              <ExitToApp className="icon" />
              <span id="logout">Вихід</span>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
